
export const authConfig = function(): any
{
    const scopes = "address email mit:user:all.read openid phone profile offline_access";
    const issuer = "https://okta.mit.edu/oauth2/aus6shg1319alZcDf697";
    const clientId = "0oawacdhkv98luHjz697";
    const serverId = "aus6shg1319alZcDf697";

    return {
        development: {
            issuer: issuer,
            clientId: clientId,
            postLogoutRedirectUri: "http://localhost:9003",
            serverId: serverId,
            redirectUri: "http://localhost:9003",
            scopes: scopes,
        }, dev: {
            issuer: issuer,
            clientId: clientId,
            serverId: serverId,
            redirectUri: "https://canopy-portal.atlas-apps-dev.mit.edu",
            postLogoutRedirectUri: "https://canopy-portal.atlas-apps-dev.mit.edu",
            scopes: scopes,
        }, test: {
            issuer: "https://okta.mit.edu/oauth2/aus6shd5478WH30vd697",
            clientId: '0oawtfkpktpdQOdz3697',
            serverId: 'aus6shd5478WH30vd697',
            redirectUri: "https://canopy-portal.atlas-apps-test.mit.edu",
            postLogoutRedirectUri: "https://canopy-portal.atlas-apps-test.mit.edu",
            scopes: scopes,
        }, prod: {
            issuer: "https://okta.mit.edu/oauth2/aus6sh93rjqnQuszg697",
            clientId: '0oawtfvlruQ0Wpa3C697',
            serverId: 'aus6sh93rjqnQuszg697',
            redirectUri: "https://canopy.mit.edu",
            postLogoutRedirectUri: "https://canopy.mit.edu",
            scopes: scopes,
        }
    };
};
